export enum ProductVendor {
    Unknown = 0,
    Webtech = 1,
    Calamp = 8,
    Garmin = 10,
    Squarell = 11,
    IntelligentTelematics = 16,
    TachoSys = 23,
    VisionTrack = 30,
    Geotab = 34,
    Alcolock = 64,
    AAMP = 66,
    Streamax = 67,
    Astra = 69,
    Falcom = 70,
    Trakm8 = 72,
    SevenTelematics = 73,
    RTL = 75,
    Aplicom = 76,
    Queclink = 84,
    Geometris = 85,
    AssuredTechmatics = 91,
    Axscend = 93,
}


//0 Unknown
//1 WebTech
//2 INS
//4 Phone Tracker
//5 Orion
//6 Box
//7 iPhone
//8 CalAmp
//9 Mobile Devices
//10 Garmin
//11 Squarell
//12 Peripheral
//13 Unit Wiring
//14 Installation Extra
//15 Engineering Stock
//16 Intelligent Telematics
//17 NeoCom
//18 Mio
//19 DVR
//20 Unknown
//21 Autoloc
//22 SecureSeal
//23 TachoSys
//24 Verilocation
//25 CoPilot
//26 SpeedGauge
//27 Armour Automotive
//28 RugGear
//29 Servision
//30 VisionTrack
//31 Transend
//32 Unknown
//33 Isotrak
//34 Geotab Inc
//35 QinetiQ
//36 Novacom Europe BV
//37 RS Components Ltd
//38 A Latter & Co Ltd
//39 Alba Engineering Ltd
//40 Arkle Electronic Systems
//41 ASM Technologies Ltd
//42 Beal(UK) Ltd
//43 Betterbox Communications Ltd
//44 Borsig
//45 Inventure ZRT
//46 Ecopac(UK) Ltd
//47 Farnell
//48 HomeChip
//49 Greenway Electronic Co Ltd
//50 Hubs Trailer Service Inc
//51 Knorr - Bremse
//52 LCP Automotive
//53 Micronet Inc
//54 Nemesis GB Ltd
//55 RAM Mount UK Ltd
//56 Truckeast Ltd
//57 Digital Distribution(GB) Ltd
//58 Co - Star Components
//59 Symec Technologies Ltd
//60 Strike Group Australia Pty Ltd
//61 SIGNO Communication Electronics
//62 Montrose Fasteners
//63 AVR Global Technologies
//64 Alcolock
//65 Autowatch
//66 AAMP Global
//67 Streamax
//68 North America & Canada
//69 Astra
//70 Falcom
//71 Seven - Demo
//72 Trackm8
//73 Seven Telematics
//74 Development
//75 RTL
//76 Aplicom
//77 Aeris
//78 Jinchanggps
//79 Technoton
//80 Eversmart
//81 Ti - Lane Precision Electronic Co Ltd
//82 Trimble
//83 ALK
//84 Queclink
//85 Peak Ryzex
//86 Geometris
//88 ATAG
//89 Amazon
//90 GPS LockBox
//91 Assured Techmatics
//92 Lightfoot
//93 Axscend
